import React from 'react';

const IconGmail = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-gmail"
  >
    <title>Gmail</title>
    <path d="M22 5.54v12.91a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5.54a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"></path>
    <path d="M22 5.54L12 13 2 5.54"></path>
  </svg>
);

export default IconGmail;
